import { inject, Pipe, PipeTransform } from '@angular/core';
import { AttachmentBerichtDto, BestandMetadataDto, GesprekId } from 'parkour-web-app-dto';
import { BerichtenService } from '../../service/berichten.service';
import { defer, delay, EMPTY, expand, last, Observable, of, take, tap } from 'rxjs';

@Pipe({
  name: 'imagePreviewMeta',
  standalone: true,
})
export class ImagePreviewMetaPipe implements PipeTransform {
  private readonly berichtService = inject(BerichtenService);

  private shouldWaitOnPreview(contentType: string) {
    switch (contentType) {
      case 'jpeg':
      case 'jpg':
      case 'png':
      case 'gif':
        return true;
      default:
        return false;
    }
  }

  transform(
    gesprekId: GesprekId,
    bericht: AttachmentBerichtDto,
    metadata: BestandMetadataDto,
    callback?: () => void,
  ): Observable<BestandMetadataDto> {
    const contentType = metadata.name.split('.')[1];
    if (this.shouldWaitOnPreview(contentType)) {
      const maxRetries = 5;
      const delayMs = 1200;
      return defer(() =>
        this.berichtService.getBestandMetadata(gesprekId, bericht.id, bericht.bestandId),
      ).pipe(
        expand((result, retryCount) => {
          if (!result.hasPreview && retryCount < maxRetries) {
            return defer(() =>
              this.berichtService.getBestandMetadata(gesprekId, bericht.id, bericht.bestandId),
            ).pipe(delay(delayMs));
          }
          return EMPTY;
        }),
        take(maxRetries),
        last(),
        tap(() => {
          if (callback) {
            callback();
          }
        }),
      );
    } else {
      return of(metadata);
    }
  }
}
